import config from './config.js';

import './blocks/index.js';
import './components/index.js';
import './sections/index.js';
import { set as mediaQuerySet } from './modules/media-queries.js';

if (config.mediaQueries) {
  mediaQuerySet(config.mediaQueries);
}
